$(".swiper-container").each(function () {
  let mySwiper;
  const el = $(this)[0];
  const options = {
    loop: false,
    autoHeight: false,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    watchOverflow: true,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
        allowTouchMove: false,
      },
    },
  };

  mySwiper = new Swiper(el, options);
});
